import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    registerList: [],
}

const mutations = {
    SET_REGISTERINDEX_LIST(state, data) {
        state.registerList = data.message
    }

}

const actions = {
    fetchRegisterDetailsList({
        commit,
        dispatch
    }) {
        Nprogress.start()
        axios.get('/register/index_list')
            .then(res => {
                Nprogress.done()
                if (res.data.loginUrl == "/signin") {
                    window.location.href = res.data.loginUrl
                }
                commit('SET_REGISTERINDEX_LIST', res.data)
                
            })
            .catch((error) => {
                if (error.response.status == 302) {
                    window.location.href = "/signin"
                }
            })
    },
    createRegisterSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/register/create', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != "success") {
                        reject(response.data)
                        return;
                    }
                    resolve(response.data);

                })
                .catch((error) => {
                    window.location.reload()

                });
        });
    },
    createRegisterSubmit1({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/register/account_register', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != "success") {
                        reject(response.data)
                        return;
                    }
                    resolve(response.data);

                })
                .catch((error) => {
                    window.location.reload()

                });
        });
    },
    changepasswordRegisterSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/register/change_password', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != "success") {
                        reject(response.data)
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => {
                    console.log(error.response.status)
                    if (error.response.status == 302) {
                        window.location.href = "/signin"
                    }
                }
                );
        });
    },

}

const getters = {
    registerIndexListGetters: state => {
        return state.registerList;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}